import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import {
  ActivityIndicator,
  StyleProp,
  Text,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';

export type ButtonProps = {
  title: string;
  loading?: boolean;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  testID?: string;
  onPress?: () => void;
};

export const Button = memo((props: ButtonProps) => {
  const { disabled, loading } = props;
  const { rpx } = useResponsiveContext();

  return (
    <TouchableOpacity
      testID={props.testID}
      onPress={props.onPress}
      disabled={disabled ?? loading}
      css={`
        height: ${rpx(50)}px;
        border-radius: ${rpx(25)}px;
        min-width: ${rpx(80)}px;
        padding: 0 ${rpx(35)}px;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      `}
      style={props.style}
    >
      {loading && (
        <ActivityIndicator
          size="small"
          css={`
            margin-left: ${rpx(-12)}px;
            margin-right: ${rpx(4)}px;
            transform: scale(0.75);
          `}
          color={'white'}
        />
      )}
      <Text
        css={`
          font-family: ${FontFamily.NotoSans.Regular};
          font-size: ${rpx(14)}px;
          letter-spacing: 0.34px;
          text-align: center;
          line-height: ${rpx(22)}px;
          margin-right: ${rpx(loading ? -12 : 0)}px;
        `}
        style={props.textStyle}
      >
        {props.title}
      </Text>
    </TouchableOpacity>
  );
});
